import React, { useRef, useCallback } from "react";
import { Form, Input, Button, Select, DatePicker, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

/**
 * 发件箱筛选组件
 *
 * @param {Function} onSearch - 搜索回调，接收表单值
 * @param {Function} onReset - 重置回调
 * @param {boolean} autoApply - 是否自动应用筛选（用于 CollapsibleFilterBar 模式）。
 *   为 true 时：表单值变化自动触发 onSearch（防抖 500ms），隐藏搜索/重置按钮。
 *   为 false 时：保持传统的手动点击"搜索"行为。
 */
const OutboxFilter = ({ onSearch, onReset, autoApply = false }) => {
    const [form] = Form.useForm();
    const debounceRef = useRef(null);

    const handleSearch = useCallback(() => {
        const values = form.getFieldsValue();
        onSearch(values);
    }, [form, onSearch]);

    const handleReset = useCallback(() => {
        form.resetFields();
        onReset();
    }, [form, onReset]);

    // autoApply 模式：表单值变化自动触发搜索（防抖）
    const handleValuesChange = useCallback(() => {
        if (!autoApply) return;
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSearch();
        }, 500);
    }, [autoApply, handleSearch]);

    // 邮件状态选项
    const statusOptions = [
        { value: "PendingSend", label: "待发送" },
        { value: "Sent", label: "已发送" },
        { value: "Failed", label: "发送失败" },
    ];

    return (
        <Form form={form} layout="inline" style={{ width: "100%" }} onValuesChange={handleValuesChange}>
            <Row gutter={[16, 16]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={6} lg={5}>
                    <Form.Item name="subject" style={{ width: "100%", marginBottom: 0 }}>
                        <Input placeholder="邮件主题" allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={5}>
                    <Form.Item name="to_address" style={{ width: "100%", marginBottom: 0 }}>
                        <Input placeholder="收件人邮箱" allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={4}>
                    <Form.Item name="status" style={{ width: "100%", marginBottom: 0 }}>
                        <Select placeholder="邮件状态" allowClear options={statusOptions} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={6}>
                    <Form.Item name="dateRange" style={{ width: "100%", marginBottom: 0 }}>
                        <RangePicker style={{ width: "100%" }} placeholder={["开始日期", "结束日期"]} />
                    </Form.Item>
                </Col>
                {/* autoApply 模式下隐藏手动搜索/重置按钮 */}
                {!autoApply && (
                    <Col xs={24} sm={24} md={24} lg={4}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                搜索
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                        </Space>
                    </Col>
                )}
            </Row>
        </Form>
    );
};

export default OutboxFilter;
